import type { HelpFile } from '../../types/help'
import { AccessRequestDetailTestIds } from '../../../testids/AccessRequestDetailTestIds'

export const accessRequestDetailHelp: HelpFile = {
  docPage: '/docs/governance/access-requests',
  texts: {
    [AccessRequestDetailTestIds.accessRequestDetailPage]:
      'Full detail of an access request — beneficiary, requested items, justification, and approval status. From here you can cancel the request or individual items while the workflow is still pending.',
    [AccessRequestDetailTestIds.cardTitleRequestItems]: 'Items included in this request. Each item carries its own approval state and can be cancelled independently while the request is pending.',
    [AccessRequestDetailTestIds.cardTitleRequestDetails]: 'Metadata about this access request: requester, beneficiary, and submission timestamp.',
    [AccessRequestDetailTestIds.cardTitleJustification]: 'The business reason supplied by the requester when this access request was created.',
    [AccessRequestDetailTestIds.btnCancelRequest]: 'Cancel the entire access request. All pending items will be cancelled.',
    [AccessRequestDetailTestIds.approveDialog]: null,
    [AccessRequestDetailTestIds.rejectDialog]: null,
    [AccessRequestDetailTestIds.cancelItemDialog]: null,
    [AccessRequestDetailTestIds.cancelRequestDialog]: null,
  },
}
